<p>
  Please, enter your new password below.
</p>

<form [formGroup]="changePassForm" (ngSubmit)="savePass()" class="mt-8 space-y-8">
  <div>
    <p-floatlabel>
      <p-iconfield>
        <input
          required
          pInputText
          class="w-full"
          [type]="visiblePassword ? 'text' : 'password'"
          name="new_password"
          formControlName="new_password"
          autocomplete="new-password" />
        <label for="password">New Password</label>
        <p-inputicon
          styleClass="{{ visiblePassword ? 'pi pi-eye-slash' : 'pi pi-eye' }}"
          (click)="visiblePassword = !visiblePassword"
          style="cursor: pointer;" />
      </p-iconfield>
    </p-floatlabel>
    @if (showPasswordError()) {
      <small class="text-xs text-red-600">{{ passwordErrorMsg }}</small>
    }
  </div>

  <div>
    <p-floatlabel>
      <p-iconfield>
        <input
          required
          pInputText
          class="w-full"
          [type]="visiblePassword ? 'text' : 'password'"
          name="confirm_password"
          formControlName="confirm_password"
          autocomplete="new-password" />
        <label for="confirm_password">Confirm Password</label>
        <p-inputicon
          styleClass="{{ visiblePassword ? 'pi pi-eye-slash' : 'pi pi-eye' }}"
          (click)="visiblePassword = !visiblePassword"
          style="cursor: pointer;" />
      </p-iconfield>
    </p-floatlabel>
    @if (showConfirmPasswordError()) {
      <small class="text-xs text-red-600">{{ confirmPasswordErrorMsg }}</small>
    }
  </div>

  <p-button styleClass="mt-4"
    label="Restore Password"
    type="submit"
    fluid
    [disabled]="changePassForm.invalid" />
</form>
